<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="hint"
	[required]="required"
	[disabled]="disabled"
	[options]="adquisicionesReactivos"
	[displayWith]="displayAdquisicionReactivos"
	[value]="selectedAdquisicionReactivos"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>
